import { FeatureFlags, type Job } from '@jms/model';

export function isNativeJobGanttEnabled(flags: Readonly<Partial<Record<FeatureFlags, boolean>>> | undefined): boolean {

  return flags?.[FeatureFlags.NativeJobGantt] === true;
}

export function nativeJobGanttCommands(jobId: string): ['/jobs', 'gantt-native', string] {

  // Both editor shells navigate from different route depths; the canonical parent Job owns the URL.
  return ['/jobs', 'gantt-native', jobId];
}

export function nativeJobGanttManageUrl(job: Pick<Job, '_id' | 'source'>, proEnabled: boolean): string {

  // Match the existing Gantt return policy without changing its implementation or editor guards.
  const editor = proEnabled ? 'view-pro' : 'view';
  return `/jobs/${editor}/${job._id}/true/${job.source}`;
}
